module.exports = __webpack_public_path__ + "static/media/img_sccs.d34c1582.jpg";